var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-table-member',{attrs:{"color-icon":_vm.profile.color || '',"member":_vm.profile}})}
var staticRenderFns = []

export { render, staticRenderFns }